"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BulkDataAliasController", {
    enumerable: true,
    get: function() {
        return BulkDataAliasController;
    }
});
const _common = require("@nestjs/common");
const _express = require("express");
const _globalguard = require("~/guards/global/global.guard");
const _bulkdataaliasservice = require("~/services/bulk-data-alias.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _dataapilimiterguard = require("~/guards/data-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let BulkDataAliasController = class BulkDataAliasController {
    async bulkDataInsert(context, req, res, baseName, tableName, body, undo) {
        const exists = await this.bulkDataAliasService.bulkDataInsert(context, {
            body: body,
            cookie: req,
            baseName: baseName,
            tableName: tableName,
            undo: undo === 'true'
        });
        res.header('nc-operation-id', req.ncParentAuditId).json(exists);
    }
    async bulkDataUpdate(context, req, baseName, tableName, body) {
        return await this.bulkDataAliasService.bulkDataUpdate(context, {
            body: body,
            cookie: req,
            baseName: baseName,
            tableName: tableName
        });
    }
    // todo: Integrate with filterArrJson bulkDataUpdateAll
    async bulkDataUpdateAll(context, req, baseName, tableName, body) {
        return await this.bulkDataAliasService.bulkDataUpdateAll(context, {
            body: body,
            cookie: req,
            baseName: baseName,
            tableName: tableName,
            query: req.query
        });
    }
    async bulkDataDelete(context, req, baseName, tableName, body) {
        return await this.bulkDataAliasService.bulkDataDelete(context, {
            body: body,
            cookie: req,
            baseName: baseName,
            tableName: tableName
        });
    }
    // todo: Integrate with filterArrJson bulkDataDeleteAll
    async bulkDataDeleteAll(context, req, baseName, tableName) {
        return await this.bulkDataAliasService.bulkDataDeleteAll(context, {
            // cookie: req,
            baseName: baseName,
            tableName: tableName,
            query: req.query,
            viewName: req.query.viewId,
            req
        });
    }
    async bulkDataUpsert(context, req, baseName, tableName, body, undo) {
        return await this.bulkDataAliasService.bulkDataUpsert(context, {
            body: body,
            cookie: req,
            baseName: baseName,
            tableName: tableName,
            undo: undo === 'true'
        });
    }
    constructor(bulkDataAliasService){
        this.bulkDataAliasService = bulkDataAliasService;
    }
};
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/data/bulk/:orgs/:baseName/:tableName'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('bulkDataInsert'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Res)()),
    _ts_param(3, (0, _common.Param)('baseName')),
    _ts_param(4, (0, _common.Param)('tableName')),
    _ts_param(5, (0, _common.Body)()),
    _ts_param(6, (0, _common.Query)('undo')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        typeof _express.Response === "undefined" ? Object : _express.Response,
        String,
        String,
        Object,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], BulkDataAliasController.prototype, "bulkDataInsert", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/data/bulk/:orgs/:baseName/:tableName'
    ]),
    (0, _extractidsmiddleware.Acl)('bulkDataUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseName')),
    _ts_param(3, (0, _common.Param)('tableName')),
    _ts_param(4, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], BulkDataAliasController.prototype, "bulkDataUpdate", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/data/bulk/:orgs/:baseName/:tableName/all'
    ]),
    (0, _extractidsmiddleware.Acl)('bulkDataUpdateAll'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseName')),
    _ts_param(3, (0, _common.Param)('tableName')),
    _ts_param(4, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], BulkDataAliasController.prototype, "bulkDataUpdateAll", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v1/db/data/bulk/:orgs/:baseName/:tableName'
    ]),
    (0, _extractidsmiddleware.Acl)('bulkDataDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseName')),
    _ts_param(3, (0, _common.Param)('tableName')),
    _ts_param(4, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], BulkDataAliasController.prototype, "bulkDataDelete", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v1/db/data/bulk/:orgs/:baseName/:tableName/all'
    ]),
    (0, _extractidsmiddleware.Acl)('bulkDataDeleteAll'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseName')),
    _ts_param(3, (0, _common.Param)('tableName')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], BulkDataAliasController.prototype, "bulkDataDeleteAll", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/data/bulk/:orgs/:baseName/:tableName/upsert'
    ]),
    (0, _extractidsmiddleware.Acl)('bulkDataUpsert'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('baseName')),
    _ts_param(3, (0, _common.Param)('tableName')),
    _ts_param(4, (0, _common.Body)()),
    _ts_param(5, (0, _common.Query)('undo')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        Object,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], BulkDataAliasController.prototype, "bulkDataUpsert", null);
BulkDataAliasController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_dataapilimiterguard.DataApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _bulkdataaliasservice.BulkDataAliasService === "undefined" ? Object : _bulkdataaliasservice.BulkDataAliasService
    ])
], BulkDataAliasController);
